import { Component, Inject, Input} from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT, Location } from '@angular/common';
import { Detalhamento } from '../detalhamento';

@Component({
    selector: 'store-cabecalho-produto',
    templateUrl: './cabecalho-produto.component.html',
    styleUrls: ['./cabecalho-produto.component.scss']
})
export class CabecalhoProdutoComponent {

    @Input()
    public detalhamento: Detalhamento;

    constructor(private router: Router, @Inject(DOCUMENT) private document: Document, private location: Location)  { }

    home() {
        this.router.navigate(['/home']);
        this.document.getElementById('divBody').className = 'home';
    }

    voltar() {
        this.location.back();
    }
}
